import ContentContainer from "layout/Content/ContentContainer";
import { useEntity } from 'hooks/useEntity'
import ViewProfiles from "pages/Profile/ViewProfiles";
import Alert from "components/ui/Alert/Alert";
import { useTitle } from "hooks/useTitle";
import TopBanner from "layout/TopBanner/TopBanner";
import ViewContextProvider from "features/view/context/ViewContext";
import ImageHero from "pages/Profile/assets/hero-leden-zoeken.png?v2";
import { useLocationAwareSortOptions } from "hooks/useLocationAwareSortOptions";

function ProfileSearch({ title }) {
  const { entity, error } = useEntity('/leden', 'page');
  const sortOptions = useLocationAwareSortOptions();
  useTitle(title);

  if (error) {
    return <Alert message={ error }/>;
  }

  return (
    <>
      <TopBanner title={ entity?.title?.value || '' }
                 intro={ entity?.field_intro?.value || '' }
                 image={ ImageHero }
                 sortOptions={ sortOptions }/>
      <ContentContainer contentBackground={ true }>
        <div className={ 'grid' }>
          <ViewContextProvider name={ 'profile' }>
            <ViewProfiles/>
          </ViewContextProvider>
        </div>
      </ContentContainer>
    </>
  )
}

export default ProfileSearch;
